import type { BlockSpeechBubbleFragment } from '@dreamstack/investors-graphql'
import type { FunctionComponent } from 'react'
import tw from 'twin.macro'

const SpeechTriangle = tw.div`z-index[-10] -translate-y-1/2 -rotate-90 left-[15px] w-0 h-0 border-b-accentroGray-full border-b-[67px] border-l-[67px] border-l-transparent absolute md:( left-auto right-[15px] bottom-[32px] rotate-45 -translate-y-full translate-x-1/2 )`
export const DarkSpeechBubble: FunctionComponent<React.PropsWithChildren<{
  block: BlockSpeechBubbleFragment
}>> = ({ block }) => {
  const textField = block.text

  return (
    <div tw="relative pb-px-32 md:(mr-px-32 pb-0)">
      <div tw="bg-accentroGray-full text-accentroWhite-full flex items-center flex-nowrap p-px-24 pb-px-32 md:(p-px-40 pb-px-48) w-full">
        <p tw="text-px-20 leading-px-30 md:(text-px-28 leading-px-42)">
          &ldquo;{textField}&rdquo;
        </p>
      </div>
      <SpeechTriangle />
    </div>
  )
}
